import {FilterType, FilterValue} from "../../../../types/filter";
import {
    OrganManagerShareFilterWordType, OrganManagerShareListQueryType,
} from "../../../../types/organShare";
import {useListSearchParams} from "../../../../hooks/list/useListSearchParams";
import {PageSearchCondition} from "../../../../types/page";
import {useCallback, useMemo, useState} from "react";
import {useFilterValues} from "../../../../hooks/list/useFilterValues";

export interface OrganManagerShareFilterValues {
    searchWordTypeFilterValue: FilterValue<OrganManagerShareFilterWordType>;
    searchWordFilterValue: FilterValue<string>;
}
export function useOrganManagerShareFilterValues() {
    const [searchWordType, setSearchWordType] = useState('');
    const [searchWord, setSearchWord] = useState("");
    const [pageInfoOnFilter, setPageInfoOnFilter] = useState<PageSearchCondition>({});

    const { listQueryType, setUrlSearchParams } = useListSearchParams<OrganManagerShareListQueryType>();

    // 필터 영역
    const filterValueArray: FilterValue<any>[] = useMemo(
        () => [
            {
                key: "searchWordType",
                value: searchWordType,
                setter: setSearchWordType,
                defaultValue: '',
                type: FilterType.OTHER,
            },
            { key: "searchWord", value: searchWord, setter: setSearchWord, defaultValue: "", type: FilterType.STRING },
        ],
        [searchWordType, searchWord]
    );

    const { getFilterValueByKey } = useFilterValues({
        filterValueArray,
        listQueryType: listQueryType,
        setPageInfoOnFilter,
    });

    const filterValues = useMemo(
        () =>
            ({
                searchWordTypeFilterValue: getFilterValueByKey("searchWordType") as FilterValue<OrganManagerShareFilterWordType>,
                searchWordFilterValue: getFilterValueByKey("searchWord") as FilterValue<string>,
            } as OrganManagerShareFilterValues),
        [getFilterValueByKey]
    );

    const searchList = useCallback(
        (pageSearchCondition: PageSearchCondition, listQueryTypeParam?: OrganManagerShareListQueryType) => {
            const param: OrganManagerShareListQueryType = {
                searchWordType: listQueryTypeParam?.searchWordType,
                searchWord: listQueryTypeParam?.searchWord,
            };

            return () => setUrlSearchParams(param, pageSearchCondition);
        },
        [setUrlSearchParams]
    );

    return{
        pageInfoOnFilter,
        filterValues, searchList,
        listQueryType
    }
}